/**
 * Critical CSS Inliner
 * Inlines critical CSS to improve First Contentful Paint and Largest Contentful Paint
 */

export const criticalCSS = `
/* Critical CSS for above-the-fold content */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}
`;

/**
 * Initialize critical CSS (deferred to idle). Only injects box-sizing/body; no 404 requests.
 */
export function initializeCriticalCSS(): void {
  if (document.querySelector('#critical-css')) return;
  const style = document.createElement('style');
  style.id = 'critical-css';
  style.textContent = criticalCSS;
  document.head.appendChild(style);
}
